export default "__VITE_ASSET__da7d56f9__"